// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2zESX","legacyBtn":"MutateMid_legacyBtn__2kzDc"};